export class SaasMicrosoft365UserProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "userPrincipalName",
            "baseName": "userPrincipalName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasMicrosoft365UserProperties.attributeTypeMap;
    }
    constructor() {
    }
}
